import React, { Suspense } from 'react';
import './App.css';
import { Navigate, Route, unstable_HistoryRouter as HistoryRouter, Routes } from 'react-router-dom';
import AtsApp, { PublicRoutes } from './AtsApp';
import AtsAppLandloard from './AtsAppLandloard';
import { GoogleTranslateManager } from './componets/common/GoogleTranslate';
import ArgyleBankReturnPage from './componets/ArgyleBankReturnPage';
import browserHistory from './browserHistory';



const LazyDocupload = React.lazy(() => import('./Docupload'));
const LazyMyML = React.lazy(() => import('./MyML'));


const App = () => {
  return <HistoryRouter history={browserHistory as any}>
    <GoogleTranslateManager />
    <Routes>
      <Route path='/ml/*' element={<Suspense fallback={<div>Loading...</div>}>
        <LazyMyML />
      </Suspense>} />

      <Route path='/ats/*' element={<AtsApp />} />

      <Route path='/landlord/*' element={<Navigate to="/ats/login" replace />} />

      <Route path='/landloard/*' element={<AtsAppLandloard />} />

      <Route path='/atss/*' element={<PublicRoutes />} />
      <Route path='/admin/*' element={
        <Suspense fallback={<div>Loading...</div>}>
          <LazyDocupload />
        </Suspense>} />
      {/* Argyle bank redirect-back landing — no auth required */}
      <Route path='/argyle-bank-return' element={<ArgyleBankReturnPage />} />
      <Route path='/' element={<Navigate to="/ats" replace />} />
      <Route path='*' element={<Navigate to="/ats" replace />} />

    </Routes>
  </HistoryRouter>
};

export default App;
